/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Push_LabelInputs */

const en_us2_profile_push_label = /** @type {(inputs: Profile_Push_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications on this device`)
};

const pt_br2_profile_push_label = /** @type {(inputs: Profile_Push_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações neste aparelho`)
};

const es_419_profile_push_label = /** @type {(inputs: Profile_Push_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones en este dispositivo`)
};

const pt_pt2_profile_push_label = /** @type {(inputs: Profile_Push_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações neste dispositivo`)
};

const fr_fr2_profile_push_label = /** @type {(inputs: Profile_Push_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications sur cet appareil`)
};

const de_de2_profile_push_label = /** @type {(inputs: Profile_Push_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen auf diesem Gerät`)
};

const it_it2_profile_push_label = /** @type {(inputs: Profile_Push_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche su questo dispositivo`)
};

/**
* | output |
* | --- |
* | "Notifications on this device" |
*
* @param {Profile_Push_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_push_label = /** @type {((inputs?: Profile_Push_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Push_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_push_label(inputs)
	if (locale === "es-419") return es_419_profile_push_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_push_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_push_label(inputs)
	if (locale === "de-DE") return de_de2_profile_push_label(inputs)
	if (locale === "it-IT") return it_it2_profile_push_label(inputs)
	return en_us2_profile_push_label(inputs)
});
export { profile_push_label as "profile.push_label" }